// Volume unit conversion + formatting for the depletions view.
//
// The HY backend reports volumes in **9-liter equivalent cases** (the
// alcohol industry's standard unit — one 9L case = 12 bottles × 750ml).
// Reps think in **6-packs**, where 1 case = 2 six-packs, so every
// surface converts on the way out and shows 6-packs.
//
// One source of truth for the conversion + presentation so every
// surface across the dashboard (KPI tiles, table cells, chart
// tooltips) shows the same numbers in the same shape.
//
// There were once parallel 9L formatters here for a dual-unit display
// ("495 6-pk · 247 9L"). Nothing renders 9L any more — the unit only
// exists as the wire format — so the formatters went with the views
// that used them.

const SIX_PK = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });

/** Convert 9-liter case count to 6-pack equivalent. 1 case = 2 6-packs. */
export function toSixPacks(cases9L: number | string): number {
  const v = typeof cases9L === 'string' ? Number(cases9L) : cases9L;
  if (!Number.isFinite(v)) return 0;
  return v * 2;
}

/** "247.3" → "495". Always rounded — half-packs don't exist. */
export function fmt6PkNumber(cases9L: number | string): string {
  return SIX_PK.format(toSixPacks(cases9L));
}
